@if (viewRelatedCourseData()?.status && relatedCourseId) {
  <div class="flex_gap p-b-20">
    <div class="status_fex">
      <div class="first_campus_status width_40">
        <p>Status: </p><span
      class="badge badge-text {{viewRelatedCourseData()?.status?.toLowerCase()}}">{{viewRelatedCourseData()?.status}}</span>
    </div>
    <div class="first_campus_status">
      <p>Updated: </p><span>{{viewRelatedCourseData()?.updatedByUserFirstname}}
    {{viewRelatedCourseData()?.updatedByUserLastname}} ({{viewRelatedCourseData()?.updatedAt}})</span>
  </div>
</div>
<div class="status_fex">
  <div class="first_campus_status width_40">
    <p>ID: </p><span>{{relatedCourseId}}</span>
  </div>
  <div class="first_campus_status">
    <p>Created: </p><span>{{viewRelatedCourseData()?.createdByUserFirstname}}
  {{viewRelatedCourseData()?.createdByUserLastname}} ({{viewRelatedCourseData()?.createdAt}})</span>
</div>
</div>
</div>
}
@if (relatedCourseForm() && relatedCourseFields() && relatedCourseFields().length) {
  <div class="course_group_form rel_course_disabled"
    [formGroup]="relatedCourseForm()!">
    @for (field of relatedCourseFields(); track field) {
      <div class="input_sec" roleAccessControl [fieldId]="field.fieldId" #fieldAccessControl="accessControl"
        [ngClass]="{'inatke_disable': ((pageType==='view') || (fieldAccessControl?.accessControl==='view') || field.readOnly), 'input_error':submitFlag && ((field.fieldType==='AJAX' && relatedCourseForm()!.get(field.fieldId)?.hasError('notFound'))?!(relatedCourseAjaxData[field.fieldId?.toLowerCase()]|searchFilter:(relatedCourseForm()!.get(field.fieldId)?.value?.id || relatedCourseForm()!.get(field.fieldId)?.value):field.minLength:'name')?.length:relatedCourseForm()!.get(field.fieldId)?.errors)}">
        <div class="input_label input_help_info">{{field.fieldName}}@if (field.mandatory==='Y') {
          <span>*</span>
        }
        @if (field.helpText) {
          <span class="material-icons-outlined info_tooltip">info
            <span class="help_ctnt">{{field.helpText}}</span>
          </span>
        }
      </div>
      @switch (field.fieldType) {
        @case ('SELECT_BOX') {
          <mat-form-field appearance="fill">
            <mat-label class="select_lb">{{(pageType==='view'&&relatedCourseForm()!.get(field.fieldId)?.value) ? relatedCourseForm()!.get(field.fieldId)?.value : ('Select '+field.fieldName)}}</mat-label>
            <mat-select disableRipple [id]="field.fieldId" [formControlName]="field.fieldId" (selectionChange)="enableFields(field, $event.value, 'clear')" [disabled]="(fieldAccessControl?.accessControl==='view')">
              <mat-option [value]="">Select {{field.fieldName}}</mat-option>
              @for (option of relatedCourseRefValues[field.fieldId?.toLowerCase()]; track option) {
                <mat-option [value]="option">
                  {{option.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (submitFlag && relatedCourseForm()!.get(field.fieldId)?.errors) {
            <div class="error_msg">
              @if (relatedCourseForm()!.get(field.fieldId)?.hasError('required')) {
                <p>Please select the {{field.fieldName}}
                </p>
              }
            </div>
          }
        }
        @case ('AJAX') {
          @if (pageType==='view'&&relatedCourseForm()!.get(field.fieldId)?.value) {
            <mat-form-field appearance="fill">
              <input matInput [id]="field.fieldId" [formControlName]="field.fieldId"
                [value]="(pageType==='view'&&relatedCourseForm()!.get(field.fieldId)?.value) ? relatedCourseForm()!.get(field.fieldId)?.value : ''">
              </mat-form-field>
            } @else {
              <mat-form-field appearance="fill">
                <input matInput [matAutocomplete]="auto" [id]="field.fieldId" [formControlName]="field.fieldId" #selectedValue (click)="checkFieldValues($event, field.fieldId)"
                  [value]="(pageType==='view'&&relatedCourseForm()!.get(field.fieldId)?.value) ? relatedCourseForm()!.get(field.fieldId)?.value : ''" [readonly]="(fieldAccessControl?.accessControl==='view')">
                  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                    @for (option of (relatedCourseAjaxData[field.fieldId]|searchFilter:(selectedValue.value):field.minLength:'name'); track option) {
                      <mat-option
                        [value]="option">
                        {{option.name}}
                      </mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
                @if (submitFlag && relatedCourseForm()!.get(field.fieldId)?.errors) {
                  <div class="error_msg">
                    @if (relatedCourseForm()!.get(field.fieldId)?.hasError('required')) {
                      <p>Please enter the {{field.fieldName}}
                      </p>
                    }
                    @if (relatedCourseForm()!.get(field.fieldId)?.hasError('minLength')) {
                      <p>Please enter a minimum of 3
                      characters</p>
                    }
                    @if (relatedCourseForm()!.get(field.fieldId)?.hasError('notFound') && !(relatedCourseAjaxData[field.fieldId]|searchFilter:(selectedValue.value):3:'name')?.length) {
                      <p
                        >
                      No results found</p>
                    }
                  </div>
                }
              }
            }
          }
        </div>
      }
    </div>
  }